import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { cargar_CuentasBancarias } from '../../actions/bancos/act_banc01';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { cargarCatalogos } from '../../funciones_globales/catalogos';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormBanco09  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fechaDesde: null,
            fechaHasta: null,
            catalogoCtasBancarias: [],
            cuenta_sel: null,
            tiposMov: [],
            tipoMov_sel: null,
            esFechaIngreso: false
        };
        
        this.limpiar = this.limpiar.bind(this);
        this.imprimirResumenDepositoEfectivo = this.imprimirResumenDepositoEfectivo.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    componentDidMount(){
        try {
            Promise.all([
                cargarCatalogos('TIPODEPO'),
                this.props.cargar_CuentasBancarias('CC'),
                this.props.generar_LogAuditoriaIngresoForm('0709')
             ])
            .then(([tiposMovDeposito]) => {
                let cuentasBancarias = this.props.cuentasBancarias;
                let catalogoCtasBancarias = [];
                cuentasBancarias.forEach(item => {                    
                    catalogoCtasBancarias.push({value: item.Cuenta, label: `${item.Nombre.toString().trim().toUpperCase()} (${item.Numero.toString().trim()})`});                    
                });
                
                let fechaProceso = getFechaProcesoPorModulo('07');
                this.setState({ fechaDesde: moment(fechaProceso, "DD/MM/YYYY"),
                                fechaHasta: moment(fechaProceso, "DD/MM/YYYY"),
                                catalogoCtasBancarias, tiposMov: tiposMovDeposito
                });
            });
        } catch(error) {
            alert(`Ocurrió un error al cargar los valores iniciales requeridos para esta opción del sistema. Error: ${error}`);
        }
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0709');
    }
  
    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('07');
        this.setState({
            fechaDesde: moment(fechaProceso, "DD/MM/YYYY"),
            fechaHasta: moment(fechaProceso, "DD/MM/YYYY"),
            tipoMov_sel: null,
            cuenta_sel: null,
            esFechaIngreso: false
        });
    }

    imprimirResumenDepositoEfectivo(){
        let tipo, cuenta, fechaDesde, fechaHasta, opFecha;

        if(this.state.tipoMov_sel === null){
            alert('No ha seleccionado el tipo de movimiento.');
            return;
        }

        if(this.state.cuenta_sel === null){
            alert('No ha seleccionado la cuenta bancaria.');
            return;
        }

        if(!validarFechaMomentEnFormatoString(formatearFechaMoment_a_String(this.state.fechaDesde))){
            alert('La fecha Desde es inválida.');
            return;
        }
        
        if(!validarFechaMomentEnFormatoString(formatearFechaMoment_a_String(this.state.fechaHasta))){
            alert('La fecha Hasta es inválida.');
            return;
        }

        if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){
            alert('La fecha Desde no puede ser mayor que la fecha Hasta.');
            return;
        }
        
        tipo = this.state.tipoMov_sel;
        cuenta = this.state.cuenta_sel;
        fechaDesde = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde);
        fechaHasta = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);
        opFecha = (this.state.esFechaIngreso)?'FCHING':'FCHMOV';

        let parametrosRpt = `&rpt=34&param1=${fechaDesde}&param2=${fechaHasta}&param3=${tipo}&param4=${cuenta}&param5=${opFecha}`;

        visualizarReporteEnPdf(parametrosRpt);
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Resumen Depósito Efectivo</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-2' margen_arriba={20}>
                            <LabelForm>Tipo Mov.:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-3' margen_arriba={20}>
                            <ReactSelect options={ this.state.tiposMov } value={this.state.tipoMov_sel} func_onChange={(value)=>{this.setState({tipoMov_sel: value===null?null:value.value})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2' margen_arriba={5}>
                            <LabelForm>Cuenta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-5' margen_arriba={5}>
                            <ReactSelect options={ this.state.catalogoCtasBancarias } value={this.state.cuenta_sel} func_onChange={(value)=>{this.setState({cuenta_sel: value===null?null:value.value})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2' margen_arriba={5}>
                            <LabelForm>Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' margen_arriba={5}>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaEscogida)=>{this.setState({fechaDesde: fechaEscogida});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' margen_arriba={5}>
                            <LabelForm>Hasta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' margen_arriba={5}>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaEscogida)=>{this.setState({fechaHasta: fechaEscogida});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-4' margen_arriba={5}>
                            <LabelForm><input type='checkbox' name='esFechaIngreso' checked={this.state.esFechaIngreso} 
                                onChange={this.handleInputChange}/> Fecha Ingreso</LabelForm>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12' margen_arriba={20}>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm'  onClick={this.imprimirResumenDepositoEfectivo}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {cuentasBancarias: state.bancos.cuentasBancarias}
});
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cargar_CuentasBancarias}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormBanco09);